import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrderService } from '../../../../order/order.service';
import { MessageService } from '../../../../shared/services/message.service';
import { DevelopmentTask } from '../../../../shared/models/development-task.model';

@Component({
  standalone: false,
  selector: 'app-add-development-worksheet',
  templateUrl: './add-development-worksheet.component.html',
  styleUrls: ['../modal.component.scss']
})

export class AddDevelopmentWorksheetModalComponent implements OnInit {
  @Input() id: string;
  @Input() type: 'order' | 'request';
  worksheetForm: FormGroup;
  developmentJobTasks: Array<DevelopmentTask> = [];
  developmentJobTaskNames: Array<string> = [];
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder,
              private orderService: OrderService,
              private message: MessageService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getDevelopmentJobOperations();
  }

  initForm(): void {
    this.worksheetForm = this.fb.group({
      task: ['', Validators.required],
      timeDelegatedEmployee: null,
      timeConsumedEmployee: null,
      comment: ''
    });
  }

  getDevelopmentJobOperations(): void {
    this.orderService.getDevelopmentJobTasks(this.id, this.type).subscribe(
      (res: any) => {
        this.developmentJobTasks = [];
        this.developmentJobTaskNames = [];

        res.results.forEach(task => {
          this.developmentJobTasks.push(new DevelopmentTask(task));
        });

        this.developmentJobTaskNames = this.developmentJobTasks.map(task => task.comment && task.name === 'Ostalo' ? `${task.name} (${task.comment})` : task.name);
      },
      err => {
        this.message.error(err);
      }
    )
  }

  onSelectTask(operation: string): void {
    this.worksheetForm.get('name').setValue(operation);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }


  emitTrue(): void {
    const developmentTask = this.developmentJobTasks.find(task => {
      const displayName = task.comment && task.name === 'Ostalo' ? `${task.name} (${task.comment})` : task.name;
      return displayName === this.f.task.value;
    });

    const developmentTaskId = developmentTask ? developmentTask.id : null;
    const data = {...this.worksheetForm.value, developmentTaskId: developmentTaskId};
    this.responseChanged.emit(data);
  }

  get f(): any {
    return this.worksheetForm.controls;
  }
}